module.exports = __webpack_public_path__ + "img/FishOnUltimateCatch_EGM.fba0a8fc.jpg";